export type { IntroProps } from "./Intro";
export { Intro } from "./Intro";
